<template>
  <div id="app">
    <div class="Model" v-if="ModelShow">
      <div class="Login">
        <div class="close" @click="ModelShow = false">x</div>
        <div class="title">河南善信医养科技有限公司</div>
        <div class="Form">
          <div>
            <input class="input" v-model="username" placeholder="请输入账号" />
          </div>
          <div>
            <input class="input" v-model="password" placeholder="请输入密码" />
          </div>
        </div>
        <div class="Submit" @click="Submit">登录</div>
      </div>
    </div>
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/logoBanner.png" alt />
        </div>
        <!-- <div class="logo">
          <div v-if="nickname">欢迎回来 {{ nickname }}</div>
          <div v-else @click="ModelShow = true">请登录</div>
        </div> -->
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/" @click="Download('/')">首页</el-menu-item>
          <el-submenu index="/platform">
            <template slot="title">产品</template>
            <el-menu-item index="/platform">智慧养老平台</el-menu-item>
            <el-menu-item index="/hardware">智能硬件支持</el-menu-item>
            <el-menu-item index="/application">移动应用平台</el-menu-item>
            <el-menu-item index="/communityServiceCenter"
              >社区服务中心</el-menu-item
            >
          </el-submenu>
          <!-- <el-menu-item
            index="/serve"
            @click="Download('/serve'), navigator('serve')"
            >服务</el-menu-item
          > -->
          <el-menu-item
            index="/price"
            @click="Download('/price'), navigator('price')"
            >合作方式</el-menu-item
          >
          <el-menu-item
            index="/solution"
            @click="Download('/solution'), navigator('solution')"
            >解决方案</el-menu-item
          >
          <el-submenu index="/AboutUs">
            <template slot="title">关于我们</template>
            <el-menu-item
              index="/AccountDemonstration"
              @click="Download('/AccountDemonstration'), navigator('systemUse')"
              >演示账号</el-menu-item
            >
            <el-menu-item
              index="/companyIntroduction"
              @click="
                Download('/companyIntroduction'),
                  navigator('companyIntroduction')
              "
              >公司介绍</el-menu-item
            >
            <el-menu-item
              index="/information"
              @click="Download('/information'), navigator('information')"
              >养老资讯</el-menu-item
            >
            <el-menu-item
              index="/joinUs"
              @click="Download('/joinUs'), navigator('joinUs')"
              >加入我们</el-menu-item
            >
            <el-menu-item
              index="/contactUs"
              @click="Download('/contactUs'), navigator('contactUs')"
              >联系我们</el-menu-item
            >
            <!-- <el-menu-item
              index="/serviceAgreement"
              @click="
                Download('/serviceAgreement'), navigator('serviceAgreement')
              "
              >服务协议</el-menu-item
            > -->
          </el-submenu>
          <el-submenu index="/news">
            <template slot="title">其他</template>
            <el-menu-item index="/news" @click="Download('/news')"
              >新闻资讯</el-menu-item
            >
            <el-menu-item index="/product" @click="Download('/product')"
              >产品中心</el-menu-item
            >
            <el-menu-item index="/case" @click="Download('/case')"
              >平台服务</el-menu-item
            >
            <el-menu-item index="/YaoPin" @click="Download('/YaoPin')"
              >药品展示</el-menu-item
            >
            <el-menu-item index="/Qixie" @click="Download('/Qixie')"
              >医疗器械</el-menu-item
            >
            <el-menu-item index="/goin" @click="Download('/goin')"
              >走进善信</el-menu-item
            >
            <el-menu-item index="/download" @click="Download('/download')"
              >下载APP</el-menu-item
            >
          </el-submenu>
        </el-menu>
        <div style="display: flex; padding: 10px">
          <el-button type="warning" size="mini">0392-3605688</el-button>
          <el-button type="warning" size="mini" @click="navigator('systemUse')"
            >预约演示</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="
              ToWY(
                'https://shanxinyy.com/production/BackstageManagementSystem/#/login'
              )
            "
            >后台入口</el-button
          >
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="true">
        <!-- <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>走进善信</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：397626534@qq.com</span>
              <span>电话：0392-3605688</span>
              <span>地址：河南省鹤壁市金融大厦7层河南善信医养科技有限公司</span>
            </li>
          </ul>
          <img src="./assets/img/ercode.jpg" alt />
        </div> -->
        <div class="copyright">
          <p>CopyRight © 2016-2024</p>
          <P>河南善信医养科技有限公司 版权所有</P>
          <p
            @click="ToWY('https://beian.miit.gov.cn/#/Integrated/recordQuery')"
          >
            ICP备案主体信息:豫ICP备2023025629号 河南善信医养科技有限公司
          </p>
          <p>
            <span
              @click="
                ToWY('https://beian.miit.gov.cn/#/Integrated/recordQuery')
              "
              >ICP备案服务信息:豫ICP备2023025629号-1</span
            >
            网站域名:
            <span @click="ToWY('https://shanxinyy.com/')">shanxinyy.com</span>
          </p>
          <p
            style="display: flex; aline-items: center; justify-content: center"
          >
<!--            <img-->
<!--              style="width: 20px; height: 20px; margin-right: 10px"-->
<!--              src="https://app.shanxinyy.com/minio/app/common/gonganIcon.png"-->
<!--            />-->
            <img
                style="width: 20px; height: 20px; margin-right: 10px"
                src="./assets/img/homepage/gongan.png"
            />
            <a style="clore: #fff" href="" rel="noreferrer" target="_blank"
              >豫公网安备41061102000429号</a
            >
          </p>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import router from "./router";
export default {
  data() {
    return {
      router: true,
      defaultActive: localStorage.getItem("defaultActive") || "/",
      isShow: false,
      username: "",
      password: "",
      ModelShow: false, //!sessionStorage.getItem("username") ? true : false
      nickname: sessionStorage.getItem("username") || "",
    };
  },
  methods: {
    Submit() {
      if (this.username.trim().length == 0) {
        alert("账号不能为空");
        return;
      }
      if (this.password.trim().length == 0) {
        alert("密码不能为空");
        return;
      }
      alert("登录成功");
      this.nickname = this.username;
      sessionStorage.setItem("username", this.username);
      sessionStorage.setItem("password", this.password);
      this.ModelShow = false;
      this.username = this.password = "";
    },
    ToWY(url) {
      location.href = url;
    },
    navigator(name) {
      router.push({ name });
    },
    Download(defaultActive) {
      this.defaultActive = defaultActive;
      localStorage.setItem("defaultActive", defaultActive);
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 15px;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  // width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    height: 50px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  background-color: rgb(255, 118, 64, 0.9);
  padding: 20px 0;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 17px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
          font-size: 14px;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    line-height: 1.6;
    text-align: center;
    color: #fff;
    font-size: 15px;
  }
}

.Model {
  z-index: 100;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(12, 12, 12, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  .Login {
    position: relative;
    padding: 30px 200px;
    background: #fff;
    border-radius: 10px;
    font-size: 32px;
  }
  .close {
    position: absolute;
    right: 20px;
    top: 10px;
  }
  .title {
    margin-bottom: 30px;
  }
  .input {
    width: 100%;
    margin-bottom: 20px;
    padding: 30px 10px;
    font-size: 24px;
  }
  .Submit {
    border-radius: 10px;
    color: #fff;
    margin: 20px auto 0;
    font-size: 28px;
    width: 140px;
    height: 50px;
    line-height: 50px;
    background: #ff7640;
    text-align: center;
  }
}
</style>
